import { StyleSheet } from "react-native";
import { Colors } from "react-native-paper";
import { pixelDimensions } from "../../../config/utils";

const styles = StyleSheet.create({
    buttonBack: {
        alignSelf: 'flex-end',
        backgroundColor: Colors.white,
        borderRadius: pixelDimensions(6),
        paddingVertical: pixelDimensions(2),
        paddingHorizontal: pixelDimensions(6),
        marginBottom: pixelDimensions(2.5),
        marginRight: pixelDimensions(2.5),
    },
    content: {
        alignItems: "center",
        flex: 1,
        justifyContent: "center"
    },
    header: {
        paddingVertical: pixelDimensions(8),
        justifyContent: "center",
        backgroundColor: Colors.indigo800
    },
    textBack: {
        color: Colors.indigo800,
        fontFamily: 'MBold',
        fontSize: pixelDimensions(4.5),
    },
    textTitle: {
        fontSize: pixelDimensions(5),
        color: Colors.white,
        textAlign: "center"
    },
    viewBase: {
        flex: 1,
        backgroundColor: Colors.grey300
    },
})

export default styles;